<div class="ir-item-line th-filter">
  <div (click)="setOrderBy('name')" class="ir-item-cell s3 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('username')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.username' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('email')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'people.email' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('phone')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'people.phone' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter has-actions">
  <div class="ir-section--list">
    <div
      class="ir-item-line th-inspection clickable"
      *ngFor="let person of people | orderBy : orderByFieldName : direction | searchBy : query"
    >
      <div class="ir-item-cell s1">
        <div class="ir-item-selector" (click)="selectPerson(person)">
          <i class="material-icons" *ngIf="!person.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="person.selected">check_box</i>
        </div>
      </div>
      <div class="ir-item-cell s2" (click)="openPerson(person)">
        <span>{{ person?.name }}</span>
      </div>
      <div class="ir-item-cell s2" (click)="openPerson(person)">
        <span>{{ person?.username }}</span>
      </div>
      <div class="ir-item-cell s4" (click)="openPerson(person)">
        <span>{{ person?.email }}</span>
      </div>
      <div class="ir-item-cell s2 important" (click)="openPerson(person)">
        <span>{{ person?.phone }}</span>
      </div>
    </div>
    <div class="ir-item-empty ir-mv8" *ngIf="people?.length == 0">
      <p>
        <span>{{ 'people.no-persons' | translate }}</span>
      </p>
    </div>
  </div>
</div>
